var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromoPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#47CCDF",
    fillOpacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.0001,
    r: 17.6552,
    fill: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7633 27.3354C30.4319 26.4881 28.6896 27.4446 28.6896 29.0227V34.9774C28.6896 36.5556 30.4319 37.512 31.7633 36.6648L36.442 33.6874C37.677 32.9015 37.677 31.0987 36.442 30.3128L31.7633 27.3354Z",
    fill: "#47CCDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoPlayIcon);
export default __webpack_public_path__ + "static/media/promo-play-icon.384b355b62f153ff014eff705da5be91.svg";
export { ForwardRef as ReactComponent };